import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Card, ConfirmButtons } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';

const BusinessHoursConfig = (props) => {
    const defaultValues = {
        monStartTime: '', monEndTime: '',
        tueStartTime: '', tueEndTime: '',
        wedStartTime: '', wedEndTime: '',
        thuStartTime: '', thuEndTime: '',
        friStartTime: '', friEndTime: '',
        satStartTime: '', satEndTime: '',
        sunStartTime: '', sunEndTime: ''
    };
    const [model, setModel] = useState(props.businessHoursConfig || defaultValues);

    const weekDays = [
        { label: translate('config.business-hours-config.weekday-mon', 'container'), key: 'mon' },
        { label: translate('config.business-hours-config.weekday-tue', 'container'), key: 'tue' },
        { label: translate('config.business-hours-config.weekday-wed', 'container'), key: 'wed' },
        { label: translate('config.business-hours-config.weekday-thu', 'container'), key: 'thu' },
        { label: translate('config.business-hours-config.weekday-fri', 'container'), key: 'fri' },
        { label: translate('config.business-hours-config.weekday-sat', 'container'), key: 'sat' },
        { label: translate('config.business-hours-config.weekday-sun', 'container'), key: 'sun' }
    ];
    useEffect(() => {
        if (!props.businessHoursConfig) props.getBusinessHoursConfig();
    }, []);

    useEffect(() => {
        if (props.businessHoursConfig) {
            setModel({ ...props.businessHoursConfig });
        }

        // eslint-disable-next-line
    }, [props.businessHoursConfig]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const update = () => {
        if (!validateInputsRequired()) return;

        if (!validateHourIntervals()) return;

        props.updateBusinessHoursConfig(model, (data) => {
            if (data.success) {
                showMessageToastCustom(translate('info', 'general'), translate('success', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            }
            else {
                showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
            props.history.go(-1);
        });
    }

    const validateHourIntervals = () => {
        let isValid = true;
        weekDays.forEach(({ label, key }) => {
            if (model[`${key}StartTime`] !== '' && model[`${key}EndTime`] !== '') {
                const startTime = new Date(`01/01/2000 ${model[`${key}StartTime`]}`);
                const endTime = new Date(`01/01/2000 ${model[`${key}EndTime`]}`);
                if (startTime >= endTime) {
                    showMessageToastCustom(translate('warning', 'general'), `${label}: ${translate('config.business-hours-config.invalid-interval', 'container')}`, 3000, 'mdi mdi-alert-circle-outline red-text');
                    isValid = false;
                }
            }
        });
        return isValid;
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('config.business-hours-config.update-business-hours-config', 'container') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        {weekDays.map(({ label, key }) => (
                            <div className="row" style={{ marginBottom: '0px' }} key={key}>
                                <div className="outlined col s5" style={{ paddingTop: 25, fontWeight: '', marginBottom: 0 }}>
                                    {label}
                                </div>
                                <div className="input-field no-padding outlined col s3" style={{ marginBottom: 0 }}>
                                    <Input
                                        id={`${key}StartTime`}
                                        name={`${key}StartTime`}
                                        label={translate('config.business-hours-config.start', 'container')}
                                        type="time"
                                        className="center"
                                        value={model[`${key}StartTime`]}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding outlined col s3" style={{ marginBottom: 0 }}>
                                    <Input
                                        id={`${key}EndTime`}
                                        name={`${key}EndTime`}
                                        label={translate('config.business-hours-config.end', 'container')}
                                        type="time"
                                        className="center"
                                        value={model[`${key}EndTime`]}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>))}
                        {
                            checkPermission(PERMISSIONS.Warehouse_Container.Config.BussinesHourConfig) ?
                                <ConfirmButtons 
                                    onConfirm={() => update()}
                                    onCancel={() => props.history.goBack()} /> :
                                <ConfirmButtons                     
                                    onCancel={() => props.history.goBack()} />                        
                        }                            
                    </Card>
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        businessHoursConfig: state.containerReducer.businessHoursConfig
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBusinessHoursConfig: (model, callback) => {
            dispatch(ContainerService.updateBusinessHoursConfig(model, callback));
        },
        getBusinessHoursConfig: (callback) => {
            dispatch(ContainerService.getBusinessHoursConfig(callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessHoursConfig));
